import context from '@/context'
import { push } from 'react-router-redux'
import { dispatchError } from '@/utils/serverErrorHandler'

const trim = (x) => x ? x.trim() : x

const initialState = {
  units: [],
  treeData: [],
  loading: false
}

const actionTypes = {
  startAction: 'organizationalUnits/startAction',
  endAction: 'organizationalUnits/endAction',
  fetched: 'organizationalUnits/fetched',
  deleted: 'organizationalUnit/deleted'
}

const actionCreators = {
  getAll: () => (dispatch) => {
    dispatch({ type: actionTypes.startAction })
    context.api.organizationalUnitService.getOrganizationalUnits()
      .then(response => {
        const units = response.map(x => ({ ...x, name: trim(x.name), latinName: trim(x.latinName) }))
        const children = {}
        const treeData = buildTreeData(units, children)
        setParentRefs(units, children)
        dispatch({ type: actionTypes.fetched, units, treeData })
      })
      .catch(showError(dispatch))
  },
  create: (unit, noRedirect) => dispatch => {
    dispatch({ type: actionTypes.startAction })
    context.api.organizationalUnitService.create(unit)
      .then((id) => {
        dispatch(actionCreators.getAll())
        if (!noRedirect) {
          dispatch(push(`/organizational-units/${id}`))
        }
      })
      .catch(showError(dispatch))
  },
  update: unit => dispatch => {
    dispatch({ type: actionTypes.startAction })
    context.api.organizationalUnitService.update(unit)
      .then(() => {
        dispatch(actionCreators.getAll())
      })
      .catch(showError(dispatch))
  },

  delete: (id) => (dispatch) => {
    dispatch({ type: actionTypes.startAction })
    context.api.organizationalUnitService.delete(id)
      .then(() => dispatch(actionCreators.getAll()))
      .catch(showError(dispatch))
  }
}

function showError (dispatch) {
  return function (error) {
    dispatch({ type: actionTypes.endAction })
    dispatchError(dispatch, error)
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.startAction:
      return { ...state, loading: true }
    case actionTypes.endAction:
      return { ...state, loading: false }
    case actionTypes.fetched:
      return { ...state, loading: false, units: action.units, treeData: action.treeData }
    case actionTypes.deleted:
      const units = state.units.filter(x => x.id !== action.id)
      return {
        ...state,
        loading: false,
        units,
        treeData: buildTreeData(units)
      }
    default: return state
  }
}

function getAvailableParents (rootItems, unitId) {
  const items = []
  visitItems(rootItems, item => {
    if (item.organizationUnitId === unitId) return false
    items.push(item)
  })
  return items
}

function setParentRefs (units, children) {
  units.forEach(unit => {
    unit.childrenCount = children[unit.organizationUnitId] || 0
    unit.parent = null
    if (unit.organizationUnitParentId > 0) {
      const parent = units.find(x => x.organizationUnitId === unit.organizationUnitParentId)
      unit.parent = parent ? { ...parent } : null
    }
  })
}

function visitItems (items, action) {
  items.forEach(item => {
    const flag = action(item)
    if (flag !== false) {
      visitItems(item.children, action)
    }
  })
}

function buildTreeData (units, children) {
  const items = []
  fillLevelItems(children, null, units, items)
  return items
}

function fillLevelItems (children, parentId, remainingUnits, items) {
  const otherUnits = []
  for (let i = 0; i < remainingUnits.length; i++) {
    const unit = remainingUnits[i]
    if (unit.organizationUnitParentId === parentId) {
      if (parentId) children[parentId] = (children[parentId] || 0) + 1
      items.push({ ...unit })
    } else {
      otherUnits.push({ ...unit })
    }
  }
  items.forEach(item => {
    item.children = []
    fillLevelItems(children, item.organizationUnitId, otherUnits, item.children)
  })
}

export {
  initialState,
  actionTypes,
  actionCreators,
  reducer,
  getAvailableParents
}



// WEBPACK FOOTER //
// ./src/store/OrganizationalUnits.js